import React, { type ErrorInfo, type PropsWithChildren } from "react";

import * as Sentry from "@sentry/browser";
import { Icon } from "semantic-ui-react";

import { ErrorRecoveryInstructions } from "~/error/FullPageError";
import { Modal } from "~/ui/legacyFellowIndex";

import styles from "./css/errorBoundary.module.css";

type Props = PropsWithChildren<{ headerWithoutNav: React.ReactElement }>;

export class ErrorBoundary extends React.Component<Props, { hasError: boolean }> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		Sentry.captureException(error, {
			extra: { errorInfo },
		});
	}

	render() {
		if (this.state.hasError) {
			return (
				<>
					<Modal.Header>{this.props.headerWithoutNav}</Modal.Header>
					<Modal.Body dark className={styles.body}>
						<Icon name="warning sign" color="red" size="huge" />
						<h1>Something went wrong.</h1>
						<ErrorRecoveryInstructions />
					</Modal.Body>
				</>
			);
		}

		return this.props.children;
	}
}
